"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = require("egov-ui-kit/redux/form/actions");

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _set = require("lodash/set");

var _set2 = _interopRequireDefault(_set);

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

var _commons = require("egov-ui-kit/utils/commons");

var _actions2 = require("egov-ui-kit/redux/app/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//const tenantId = JSON.parse(getUserInfo()).permanentCity;
var tenantId = "ch.chandigarh";
var formConfig = {
  name: "opencomplaint",
  idJsonPath: "services[0].serviceRequestId",
  fields: {
    // media: {
    //   id: "media",
    //   jsonPath: "actionInfo[0].media",
    //   file: true,
    //   errorMessage: "CS_FILE_UPLOAD_FAILED",
    // },
    department: {
      id: "department",
      required: false,
      jsonPath: "services[0].department",
      floatingLabelText: "CS_ADDCOMPLAINT_DEPARTMENT",
      hintText: "HR_DEPARTMENT_PLACEHOLDER",
      errorMessage: "HR_DEPARTMENT_PLACEHOLDER",
      boundary: true,
      dropDownData: [],
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        if (field && field.value) {
          dispatch((0, _actions.setFieldProperty)("opencomplaint", "complaintType", "disabled", false));
        } else {
          dispatch((0, _actions.setFieldProperty)("opencomplaint", "complaintType", "disabled", true));
        }
        dispatch((0, _actions.setFieldProperty)("opencomplaint", "complaintType", "value", ""));
      },
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorText: ""
    },
    mohalla: {
      id: "mohalla",
      required: false,
      jsonPath: "services[0].addressDetail.mohalla",
      floatingLabelText: "CS_CREATECOMPLAINT_MOHALLA",
      hintText: "CS_CREATECOMPLAINT_MOHALLA_PLACEHOLDER",
      errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_TYPE_PLACEHOLDER",
      boundary: true,
      dropDownData: [],

      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorText: ""
    },
    startDate: {
      id: "startDate details",
      jsonPath: "services[0].startDate",
      // floatingLabelText: "CS_STARTDATE_COMPLAINT_DETAILS",
      // hintText: "CS_STARTDATE_COMPLAINT_DETAILS_PLACEHOLDER",
      floatingLabelText: "Start Date",
      hintText: "Select start date",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      value: "",
      required: false,
      style: { color: "#484848" },
      errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_DETAILS_VALIDATION",
      //formatDate:{"dd-mm-yyyy"},
      errorText: ""

    },
    toDate: {
      id: "toDate details",
      jsonPath: "services[0].toDate",
      // floatingLabelText: "CS_TODATE_COMPLAINT_DETAILS",
      // hintText: "CS_TODATE_COMPLAINT_DETAILS_PLACEHOLDER",
      floatingLabelText: "End Date",
      hintText: "Select end date",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      style: { color: "#484848" },
      value: "",
      required: false,
      errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_DETAILS_VALIDATION",
      // formatDate:"dd-mm-yyyy",
      errorText: ""

    },
    // complaintType: {
    //   id: "complaint-type",
    //   jsonPath: "services[0].serviceCode",
    //   required: true,
    //   floatingLabelText: "CS_ADDCOMPLAINT_COMPLAINT_TYPE",
    //   errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_TYPE_PLACEHOLDER",
    //   hintText: "CS_ADDCOMPLAINT_COMPLAINT_TYPE_PLACEHOLDER",
    // },
    // additionalDetails: {
    //   id: "additional details",
    //   jsonPath: "services[0].description",
    //   floatingLabelText: "CS_ADDCOMPLAINT_COMPLAINT_DETAILS",
    //   hintText: "CS_ADDCOMPLAINT_COMPLAINT_DETAILS_PLACEHOLDER",
    //   errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_DETAILS_VALIDATION",
    //   pattern:/^[^\$\"'<>\?~`!&@#$%^+={}\[\]*:;]{1,500}$/i, 
    //   maxlength: "500"
    // },
    // latitude: {
    //   id: "latitude",
    //   jsonPath: "services[0].addressDetail.latitude",
    // },
    // longitude: {
    //   id: "longitude",
    //   jsonPath: "services[0].addressDetail.longitude",
    // },
    // address: {
    //   id: "address",
    //   jsonPath: "services[0].address",
    //   floatingLabelText: "CS_ADDCOMPLAINT_LOCATION",
    //   hintText: "CS_COMPLAINT_DETAILS_LOCATION",
    // },
    // city: {
    //   id: "city",
    //   jsonPath: "services[0].addressDetail.city",
    //   floatingLabelText: "CORE_COMMON_CITY",
    //   hintText: "ES_CREATECOMPLAINT_SELECT_PLACEHOLDER",
    //   errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_TYPE_PLACEHOLDER",
    //   required: true,
    //   errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
    //   errorText: "",
    //   dropDownData: [],
    //   updateDependentFields: ({ formKey, field, dispatch, state }) => {
    //  //   dispatch(setFieldProperty("complaint", "mohalla", "value", ""));
    //   },
    //   beforeFieldChange: ({ action, dispatch, state }) => {
    //     if (get(state, "common.prepareFormData.services[0].addressDetail.city") !== action.value) {
    //       const moduleValue = action.value;
    //       dispatch(fetchLocalizationLabel(getLocale(), moduleValue, moduleValue));
    //     }
    //     return action;
    //   },
    //   labelsFromLocalisation: true,
    //  /* dataFetchConfig: {
    //     dependants: [
    //       {
    //         fieldKey: "mohalla",
    //       },
    //     ],
    //   }, */
    // },

    // houseNo: {
    //   id: "houseNo",
    //   jsonPath: "services[0].addressDetail.houseNoAndStreetName",
    //   floatingLabelText: "CS_ADDCOMPLAINT_HOUSE_NO",
    //   hintText: "CS_ADDCOMPLAINT_HOUSE_NO_PLACEHOLDER",
    //   errorMessage: "CS_HOUSE_NO_ERROR_MESSAGE_VALIDATION",
    //   //errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_DETAILS_VALIDATION",
    //   pattern:/^[^\$\"'<>\?~`!&@#$%^+={}\[\]*:;]{1,100}$/i, 
    // },
    // landmark: {
    //   id: "landmark",
    //   jsonPath: "services[0].addressDetail.landmark",
    //   floatingLabelText: "CS_ADDCOMPLAINT_LANDMARK",
    //   hintText: "CS_ADDCOMPLAINT_LANDMARK_PLACEHOLDER",
    //   errorMessage: "CS_ADDCOMPLAINT_LANDMARK_VALIDATION",
    //  // errorMessage: "CS_ADDCOMPLAINT_COMPLAINT_DETAILS_VALIDATION",
    //   pattern:/^[^\$\"'<>\?~`!&@#$%^+={}\[\]*:;]{1,100}$/i, 
    // },
    tenantId: {
      id: "add-complaint-tenantid",
      jsonPath: "services[0].tenantId"
    }
  },
  submit: {
    type: "submit",
    label: "SUBMIT",
    id: "addComplaint-opencomplaint-complaint"
  },
  afterInitForm: function afterInitForm(action, store, dispatch) {
    try {
      var state = store.getState();
      var localizationLabels = state.app.localizationLabels;
      var _state$common = state.common,
          cities = _state$common.cities,
          citiesByModule = _state$common.citiesByModule;
      var _state$complaints = state.complaints,
          categoriesById = _state$complaints.categoriesById,
          complaintDepartment = _state$complaints.complaintDepartment,
          complaintSector = _state$complaints.complaintSector;

      var _ref2 = citiesByModule || {},
          PGR = _ref2.PGR;

      if (PGR) {
        // for department
        var arrayOfDepartment = [];
        var i = 0;
        var getNestedObjFormat = function getNestedObjFormat(categories) {
          var categoryList = {};
          Object.values(categories).map(function (item) {
            (0, _set2.default)(categoryList, item.code, item);
          });
          return transform(categoryList);
        };

        var transform = function transform(input) {
          return Object.keys(input).reduce(function (result, itemKey) {
            var item = Object.assign({}, input[itemKey]);
            if (item && item.code) {
              if (item.code != "undefined") {
                var duplicate_flag = arrayOfDepartment.find(function (ele) {
                  return ele.value === item.code;
                });
                var DepLable = "";
                if (!duplicate_flag) {
                  var codevalue = "" + item.code;
                  if (codevalue.includes("DEP")) {
                    DepLable = "PGRDEPT." + item.code.toUpperCase();
                  } else {
                    DepLable = item.name;
                  }

                  arrayOfDepartment.push({ label: (0, _commons.getTranslatedLabel)(DepLable, localizationLabels), value: item.code });
                }
              }
              i++;
            }
            return result;
          }, []);
        };

        var categoryList = getNestedObjFormat(complaintDepartment);
        dispatch((0, _actions.setFieldProperty)("opencomplaint", "department", "dropDownData", arrayOfDepartment));
        arrayOfDepartment = [];
        var sectorList = getNestedObjFormat(complaintSector);
        dispatch((0, _actions.setFieldProperty)("opencomplaint", "mohalla", "dropDownData", arrayOfDepartment));

        var department = (0, _get2.default)(state, "form.opencomplaint.fields.department");
        if (department && department.value) dispatch((0, _actions.setFieldProperty)("opencomplaint", "complaintType", "disabled", false));else dispatch((0, _actions.setFieldProperty)("opencomplaint", "complaintType", "disabled", true));

        /*    categoryList.forEach(category => {
             
             if(category && category.nestedItems && category.nestedItems[0].department){
               arrayOfDepartment[i] = category.nestedItems[0].department;
               i++;
             }
            
        })*/
        // code change end here for department
        var tenants = PGR.tenants;
        var dd = tenants.reduce(function (dd, tenant) {
          var selected = cities.find(function (city) {
            return city.code === tenant.code;
          });
          if (selected) {
            var label = "TENANT_TENANTS_" + selected.code.toUpperCase().replace(/[.]/g, "_");
            dd.push({ label: (0, _commons.getTranslatedLabel)(label, localizationLabels), value: selected.code });
          }

          return dd;
        }, []);
        dispatch((0, _actions.setFieldProperty)("opencomplaint", "city", "dropDownData", dd));
      }
      var city = (0, _get2.default)(state, "form.opencomplaint.fields.city.value");
      // let mohalla = get(state, "form.complaint.fields.mohalla.value");
      if (!city) {
        // dispatch(handleFieldChange("opencomplaint", "city", tenantId));
      } else {
        if (city) {
          // dispatch(handleFieldChange("opencomplaint", "city", city));
        }
        if (mohalla) {
          // dispatch(handleFieldChange("opencomplaint", "mohalla", mohalla));
        }
      }
      return action;
    } catch (e) {
      console.log(e);
    }
  },
  action: "_closecomplaint",
  saveUrl: "/rainmaker-pgr/v1/requests/_search"
  // redirectionRoute: "/complaint-submitted",
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/pgr/pgr-employee/opencomplaint.js
// module id = 1982
// module chunks = 895